import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Categories from './pages/Categories';
import CategoryForm from './pages/CategoryForm';
import Subcategories from './pages/Subcategories';
import SubcategoryForm from './pages/SubcategoryForm';
import Posts from './pages/Posts';
import PostForm from './pages/PostForm';
import Users from './pages/Users';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <ToastContainer position="top-right" autoClose={3000} />
        <Routes>
          <Route path="/login" element={<Login />} />
          
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<Dashboard />} />
            
            <Route path="categories" element={<Categories />} />
            <Route path="categories/add" element={<CategoryForm />} />
            <Route path="categories/edit/:id" element={<CategoryForm />} />
            
            <Route path="subcategories" element={<Subcategories />} />
            <Route path="subcategories/add" element={<SubcategoryForm />} />
            <Route path="subcategories/edit/:id" element={<SubcategoryForm />} />
            
            <Route path="posts" element={<Posts />} />
            <Route path="posts/add" element={<PostForm />} />
            <Route path="posts/edit/:id" element={<PostForm />} />
            
            <Route path="users" element={<Users />} />
            
            <Route path="profile" element={<Profile />} />
            
            <Route path="settings" element={<Settings />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App; 